import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {MenuIconButtonPage} from '../components/menu-icon-button-page'
import {eventsFeedPage} from '../constants'
import {useMainMenuStore} from '../main-menu-store'
import {MenuButtonPage} from '../components/menu-button-page'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'

export const EventFeedMenuItem = observer(() => {
  const [state] = useMainMenuStore()
  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'profile',
    {debounceTime: 50, filter: globals.currentUserId},
    () => {
      forceUpdate()
    }
  )
  if (state.menuOpen) {
    const text = Lang.msg.menu.eventsListHint

    return (
      <MenuButtonPage page={eventsFeedPage} text={text} icon={'IconReport'} />
    )
  }

  return (
    <MenuIconButtonPage
      icon="IconReport"
      page={eventsFeedPage}
      hint={Lang.msg.menu.eventsListHint}
    />
  )
})
